/*@ngInject*/
const ModificationDetailController = function ($scope, $rootScope, $stateParams, submissionMediator, submissionConstant, coreMediator, currentSubmissionModel) {

    $scope.viewModel = {
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
        changeSetExists: false,
        changeSetSubmitted: false
    };

    function refreshSubmissionModificationInfo(submission) {
        if (submission.changeSetId) {
            $scope.viewModel.changeSetExists = true;
            submissionMediator.loadChangeSet(submission.changeSetId).then(onChangeSetLoaded);
        }
        else {
            $scope.viewModel.changeSetExists = false;
            $scope.viewModel.changeSetSubmitted = false;
        }

        function onChangeSetLoaded(changeSet) {
            if (changeSet.endTime) {
                $scope.viewModel.changeSetSubmitted = true;
            }
        }
    }


    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        if (parseInt($stateParams.submissionId) === submission.id) {
            refreshSubmissionModificationInfo(submission);
        }
    });

    refreshSubmissionModificationInfo(currentSubmissionModel.getCurrentSubmission());
};

angular.module('gw-um-submission')
    .controller('modificationController', ModificationDetailController);
